export default __webpack_public_path__ + "static/media/choose_lang.256615cf.png";